// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2691":"9cba68633362abb6","4110":"636ca158b1796141","8113":"17ff60a92d05d16d"}[chunkId] + ".js";
};